<template>
  <HomeCards
    :id="id"
    :list="experiences"
    :title="title"
  />
</template>

<script>

import HomeCards from './HomeCards.vue';

export default {
  components: {
    HomeCards,
  },
  props: {
    id: {
      type: String,
      default: 'experiences',
    },
    title: {
      type: String,
      default: 'Experiences',
    },
  },
  data() {
    return {
      experiences: [
        {
          title: 'Doctolib - Full Stack',
          period: 'March 2020 - Present',
          subtitle: 'Working on a new product for the practitioner which handle the billing of a patient during a consultation, made 1 millions bills with an average increase of bills of 50% since launch in March 2021',
          img: 'experiences/doctolib.png',
          tags: [
            'React',
            'Ruby on Rails',
            'e2e (capybara)',
          ],
          links: [
            {
              content: 'Website',
              url: 'https://www.doctolib.fr',
              pack: 'fas',
              icon: 'window-maximize',
            },
          ],
        },
        {
          title: 'IWD - FrontEnd',
          period: 'Sep 2018 - Feb 2020 (1 year 6 months)',
          subtitle: 'Working on a SaaS that helps brands (Dior, Louis Vuitton, ...) in multiple ways like managing their merchandising as well as their networks of points of sale',
          img: 'experiences/iwd.png',
          tags: [
            'ReactJS',
            'Redux',
            'Jest',
            'Code review',
            'ES6',
          ],
          links: [
            {
              content: 'Website',
              url: 'https://iwd.io',
              pack: 'fas',
              icon: 'window-maximize',
            },
          ],
        },
        {
          title: 'Yoopies - Full Stack',
          period: 'Feb 2018 - August 2018 (6 months)',
          subtitle: 'I improved the CRM (Customer Relationship Management) tool by revamping the existing features and adding new ones. I made generic and reusable components, revamp the appointment process for self-employed people',
          img: 'experiences/yoopies.png',
          tags: [
            'VueJS',
            'Symfony',
            'GraphQL',
            'Bootstrap',
            'Intercom',
            'Calendly',
            'ES6',
          ],
          links: [
            {
              content: 'Website',
              url: 'https://yoopies.fr',
              pack: 'fas',
              icon: 'window-maximize',
            },
            {
              content: 'Demo',
              url: 'https://vue-generic-table.riceflake.com',
              pack: 'fas',
              icon: 'external-link-alt',
            },
            {
              content: 'Source code',
              url: 'https://github.com/Riceflake/vue-generic-table',
              pack: 'fab',
              icon: 'github',
            },
          ],
        },
        {
          title: 'YBCDATA - Full Stack',
          period: 'Aug 2016 - Jan 2017 (6 months)',
          subtitle: 'I developed the Datascientest.com B2B platform from scratch. Using a responsive design with bootstrap, authentication system, emailing',
          img: 'experiences/datascientest.png',
          tags: [
            'JavaScript',
            'Bootstrap',
            'PHP',
            'HTML5',
            'CSS3',
            'Python',
          ],
          links: [
            {
              content: 'Website',
              url: 'https://www.datascientest.com',
              pack: 'fas',
              icon: 'window-maximize',
            },
          ],
        },
      ],
    };
  },
};
</script>
